module.exports = __webpack_public_path__ + "img/boston1.48979b87.jpg";